// Chunk & Prosody — sentences broken into meaningful phrases for guided reading.
// Each `chunks` item is a natural pause group; readers see them separated and hear
// them read with a small pause between chunks (models good prosody / phrasing).
export const PROSODY_ITEMS = [
  {
    id: "cat-moon",
    chunks: ["The little cat", "sat on the mat", "and looked at the moon."],
  },
  {
    id: "bike-hill",
    chunks: ["Every morning,", "Ben rides his bike", "up the steep hill."],
  },
  {
    id: "rain-splash",
    chunks: ["When the rain fell,", "the puddles splashed", "under our boots."],
  },
  {
    id: "bakery",
    chunks: ["The baker smiled", "as she pulled warm bread", "from the hot oven."],
  },
  {
    id: "library",
    chunks: ["In the quiet library,", "the students read books", "about faraway lands."],
  },
  {
    id: "beach",
    chunks: ["We walked along the beach,", "collecting smooth shells", "and skipping stones."],
  },
  {
    id: "garden",
    chunks: ["Bees buzzed softly", "between the yellow flowers", "in Grandma's garden."],
  },
  {
    id: "storm",
    chunks: ["The wind roared,", "the thunder cracked,", "and the lights flickered off."],
  },
];
